import { render } from "./MobileFilesComponent.vue?vue&type=template&id=3b751c46&scoped=true"
import script from "./MobileFilesComponent.vue?vue&type=script&lang=js"
export * from "./MobileFilesComponent.vue?vue&type=script&lang=js"

import "./MobileFilesComponent.vue?vue&type=style&index=0&id=3b751c46&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b751c46"]])

export default __exports__